import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scrolls to top of page on route change
 * This ensures users always see the top of the page when navigating
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top instantly on route change
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
